import React from "react";
import { Typography, Grid } from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import intervenant from "../../../../Assets/images/intervenants-matching-platform.png";
import abonnez_vous from "../../../../Assets/images/abonnez-vous-visio-matching-platform.png";
import a_boutique from "../../../../Assets/images/e-boutique-matching-platform.png";
import paxk_jetons from "../../../../Assets/images/pack-jetons-matching-platform.png";
import arrowDown from "../../../../Assets/images/ChevronDoubleDown.png";
import logo_yt_fr from "../../../../Assets/images/guide-youtube.png";
import logo_yt_en from "../../../../Assets/images/user-guide-matching-platform.png";
import "./Header.css";

function Header() {
  const navigate = useNavigate();
  const { t } = useTranslation();
    const { i18n } = useTranslation(); // <-- récupère i18n ici

const logo_yt_lang = i18n.language === "fr" ? logo_yt_fr : logo_yt_en;
  return (
    <section className="bg-header">
      <div className="first_row">
        {/* Left column: Text */}
        <div className="column" style={{ flex: "1 1 35%" }}>
          <Typography
            variant="h1"
            sx={{
              color: "var(--taupe-fonc, #3F4C52)",
              textAlign: "left",
              fontFamily: "DM Serif Display",
              fontSize: { xs: "6.5vw", sm: "6.5vw", md: "4.5vw", lg: "4.5vw" },
              fontStyle: "normal",
              fontWeight: 400
            }}
          >
            {t("connectProfiles")}
          </Typography>

          <Typography
            variant="h4"
            sx={{
              color: "var(--taupe-fonc, #2E2E2E)",
              textAlign: "left",
              fontFamily: "Lato",
              fontSize: { xs: "3vw", sm: "3vw", md: "1.2vw", lg: "1.2vw" },
              lineHeight: { xs: "20px", sm: "30px", md: "35px", lg: "35px" }
            }}
          >
            {t("platformDescription")} Soa test 11
          </Typography>

          <div className="btn-header">
            <button className="btn-more" onClick={() => navigate("/intervenants")}>
              {t("seeIntervenants")}
            </button>
            <button className="btn-contact" onClick={() => navigate("/contact")}>
              {t("contactUs")}
            </button>
          </div>
        </div>

        {/* Middle column: Cards */}
        <div className="column" style={{ flex: "1 1 40%", padding: "4%" }}>
          <Grid container spacing={{ xs: 5, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
            {/* Intervenants */}
            <Grid item xs={2} sm={4} md={6} style={{ textAlign: "center" }}>
              <NavLink to="/intervenants" style={{ textDecoration: "none" }}>
                <img
                  src={intervenant}
                  alt="intervenant"
                  style={{
                    width: "75%",
                    height: "auto",
                    boxShadow: "4px 24px 60px #3f4c5245",
                    borderRadius: "200px"
                  }}
                />
                <Typography
                  variant="h4"
                  sx={{
                    color: '#2E2E2E', fontFamily: 'Lato', fontSize: {
                      xs: "14px", // Smallest size for mobile screens 
                      sm: "16px", // Slightly larger for small screens 
                      md: "18px", // Default size for medium screens 
                      lg: "20px", // Larger size for large screens
                      xl: "20px"
                    },
                    fontStyle: 'normal', fontWeight: 500, marginTop: '20px'
                  }}
                >
                  {t("intervenants")}
                </Typography>
              </NavLink>
            </Grid>

            {/* Subscriptions */}
            <Grid item xs={2} sm={4} md={6} style={{ textAlign: "center" }}>
              <NavLink to="/subscriptions" style={{ textDecoration: "none" }}>
                <img
                  src={abonnez_vous}
                  alt="abonnez_vous"
                  style={{
                    width: "75%",
                    height: "auto",
                    boxShadow: "4px 24px 60px #3f4c5245",
                    borderRadius: "200px"
                  }}
                />
                <Typography
                  variant="h4"
                  sx={{
                    color: '#2E2E2E', fontFamily: 'Lato', fontSize: {
                      xs: "14px", // Smallest size for mobile screens 
                      sm: "16px", // Slightly larger for small screens 
                      md: "18px", // Default size for medium screens 
                      lg: "20px", // Larger size for large screens
                      xl: "20px"
                    },
                    fontStyle: 'normal', fontWeight: 500, marginTop: '20px'
                  }}
                >                  {t("subscriptions")}
                </Typography>
              </NavLink>
            </Grid>

            {/* Token Pack */}
            <Grid item xs={2} sm={4} md={6} style={{ textAlign: "center" }}>
              <NavLink to="/packs-jetons" style={{ textDecoration: "none" }}>
                <img
                  src={paxk_jetons}
                  alt="pack_jetons"
                  style={{
                    width: "75%",
                    height: "auto",
                    boxShadow: "4px 24px 60px #3f4c5245",
                    borderRadius: "200px"
                  }}
                />
                <Typography
                  variant="h4"
                  sx={{
                    color: '#2E2E2E', fontFamily: 'Lato', fontSize: {
                      xs: "14px", // Smallest size for mobile screens 
                      sm: "16px", // Slightly larger for small screens 
                      md: "18px", // Default size for medium screens 
                      lg: "20px", // Larger size for large screens
                      xl: "20px"
                    },
                    fontStyle: 'normal', fontWeight: 500, marginTop: '20px'
                  }}
                >                  {t("tokenPack")}
                </Typography>
              </NavLink>
            </Grid>

            {/* E-Boutique */}
            <Grid item xs={2} sm={4} md={6} style={{ textAlign: "center" }}>
              <a href="https://yanacom.fr/" target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
                <img
                  src={a_boutique}
                  alt="e_boutique"
                  style={{
                    width: "75%",
                    height: "auto",
                    boxShadow: "4px 24px 60px #3f4c5245",
                    borderRadius: "200px"
                  }}
                />
                <Typography
                  variant="h4"
                  sx={{
                    color: '#2E2E2E', fontFamily: 'Lato', fontSize: {
                      xs: "14px", // Smallest size for mobile screens 
                      sm: "16px", // Slightly larger for small screens 
                      md: "18px", // Default size for medium screens 
                      lg: "20px", // Larger size for large screens
                      xl: "20px"
                    },
                    fontStyle: 'normal', fontWeight: 500, marginTop: '20px'
                  }}
                >                  {t("eBoutique")}
                </Typography>
              </a>
            </Grid>
          </Grid>
        </div>

        {/* Right column: YouTube */}
        <div className="column" style={{ flex: "1 1 20%" }}>
          <NavLink to="/guide-utilisation">
 <img
          src={logo_yt_lang}
          alt="logo_youtube"
          className="logo_youtube center"
          width={"65%"}
        />
                  </NavLink>
        </div>
      </div>

      <br />
      <div>
        <img src={arrowDown} alt="arrow_Down" className="arrowDown center" />
      </div>
    </section>
  );
}

export default Header;